<div class="text-white">
  @if (collapseTrigger && !auth.engageParams) {
    <bv-dialog-title>{{ "SIGNUP" | translate }}</bv-dialog-title>
  }
  @if (collapseTrigger && auth.engageParams) {
    <bv-dialog-title>
      {{ "CREATE_2_CLICKS" | translate }}
    </bv-dialog-title>
  }
  @if (topTrigger) {
    <bv-dialog-title>{{ "SIGNUP_EMAIL" | translate }}</bv-dialog-title>
  }
  <bv-dialog-body class="signup-max">
    <div
      class="flex flex-col justify-around items-center"
      [@tdCollapse]="{ value: topTrigger, params: { duration: 200 } }"
      [style.overflow]="'hidden'"
      >
      <div>
        <button
          id="btn_signup_facebook"
          bv-button variant="primary"
          (click)="socialLogin('facebook')"
          class="mat-button-lg facebook-blue"
          >
          {{ "SIGNUP_FACEBOOK" | translate }}
        </button>
      </div>
      <div>
        <button
          id="btn_signup_google"
          bv-button variant="primary"
          (click)="socialLogin('google')"
          class="mat-button-lg google-red"
          >
          {{ "SIGNUP_GOOGLE" | translate }}
        </button>
      </div>
      <div>
        <button
          id="btn_signup_email"
          bv-button variant="primary"
          (click)="toggleCollapse()"
          class="mat-button-lg"
          >
          {{ "SIGNUP_EMAIL" | translate }}
        </button>
      </div>
      <bv-checkbox
        id="newsletter"
        data-testid="signup-newsletter-checkbox"
        [(ngModel)]="acceptNewsletter"
        class="signup-newsletter"
        >{{
        "ACCEPT_NEWSLETTER" | translate
      }}</bv-checkbox>
    </div>
    <div
      [@tdCollapse]="{ value: collapseTrigger, params: { duration: 200 } }"
      [style.overflow]="'hidden'"
      >
      <div>
        <bv-form-field label="{{ 'EMAIL' | translate }}">
          <input
            id="input_modal_create_email"
            data-testid="signup-email-input"
            bv-input
            [(ngModel)]="createEmail"
            type="email"
            />
        </bv-form-field>
        <bv-form-field label="{{ 'PASSWORD' | translate }}">
          <input
            id="input_modal_create_password"
            data-testid="signup-password-input"
            bv-input
            [(ngModel)]="createPassword"
            type="password"
            />
        </bv-form-field>
      </div>
    </div>
  </bv-dialog-body>
  @if (topTrigger) {
    <bv-dialog-footer>
      <button id="btn_signup_previous" bv-button variant="ghost" (click)="toggleCollapse()">
        {{ "PREVIOUS" | translate }}
      </button>
      <button
        id="btn_signup_create_email"
        data-testid="signup-submit-btn"
        bv-button variant="primary" [disabled]="!createEmail || !createPassword"
        (click)="createEmailPassword()"
        >
        {{ "SIGNUP" | translate }}
      </button>
    </bv-dialog-footer>
  }
</div>
